import React from 'react'

import { videoData } from '../../data/video.data'

import close from './../../UI/mobile/sidebar/close_white.svg'

interface Props{
  isVideoOpened: boolean,
  completeCar: string,
  handleIsVideoOpened: (payload: boolean) => void
}

interface State {
  currentVideoSelected: string
}

class Video extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      currentVideoSelected: ''
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    if(prevProps.isVideoOpened !== this.props.isVideoOpened && this.props.isVideoOpened){
      var currentVideoData: any = videoData()
      this.setState({
        currentVideoSelected: currentVideoData[this.props.completeCar]
      })
    }
  }

  render(): React.ReactNode {
    return(
      <div className={this.props.isVideoOpened ? 'video-container fade-in':'video-container fade-out'}>
        <div className='video-close-btn' onClick={() => {
          this.props.handleIsVideoOpened(false)
          setTimeout(() => {this.setState({currentVideoSelected: ''})}, 500)
          }}>
            <img src={close} alt=''/>
        </div>
        <div className='video-frame-container'>
          <iframe 
            src={this.props.isVideoOpened && this.state.currentVideoSelected !== '' ? this.state.currentVideoSelected +"?rel=0?version=3&autoplay=1&controls=0&loop=1&showinfo=0":""} 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"   
            className={this.props.isVideoOpened ? 'fade-in':'fade-out'} 
            title='video'
          />
        </div>
      </div>
    )
  }
}

export default Video